import { MDXEditor } from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid2'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { map } from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { ALL_PLUGINS, SHORT_PLUGINS } from '../../../../constants/plata'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import { theme } from '../../../../theme'

export const Memo = ({ recordId }) => {
    const {
        record,
        fetchMemoDetail2,
        memoDetail,
        errorFetchMemoDetail,
        errorFetchMemoList,
        updateMemo,
        isLoadingUpdateMemo,
        fetchMemoList,
        memoList,
        idActiveMemoDetail,
        setIdActiveMemoDetail,
        isLoadingFetchMemoDetail,
        fetchMemoDetail,
    } = useAssistantAdministrationStore((state) => state)
    const handleAlignment = (event: MouseEvent<HTMLElement>, newAlignment: string | null) => {
        setIdActiveMemoDetail(newAlignment)
    }
    const [md, setMd] = useState(null)

    const handleClickChange = (md) => {
        setMd(md)
    }
    const handleClickSaveChange = async () => {
        await updateMemo({ memoId: memoDetail.id }, { content: md })
    }

    useEffect(() => {
        fetchMemoList({ record_id: recordId })
    }, [])

    useEffect(() => {
        if (memoDetail?.content) {
            setMd(memoDetail.content)
        }
    }, [memoDetail])

    useEffect(() => {
        if (memoList && memoList.length > 0) {
            setIdActiveMemoDetail(memoList[0]?.id)
        }
    }, [memoList])

    useEffect(() => {
        if (idActiveMemoDetail) {
            fetchMemoDetail({ memoId: idActiveMemoDetail })
        }
    }, [idActiveMemoDetail])

    return (
        <div>
            {memoDetail && (
                <>
                    {memoList?.length > 1 && (
                        <ToggleButtonGroup
                            sx={{ mb: 3 }}
                            value={idActiveMemoDetail}
                            exclusive
                            onChange={handleAlignment}
                            aria-label="text alignment">
                            {map(memoList, (item, index) => {
                                return (
                                    <ToggleButton value={item.id}>
                                        Саммари 00{index} от{' '}
                                        {moment(item.created_at).format('DD.MM')}
                                    </ToggleButton>
                                )
                            })}
                        </ToggleButtonGroup>
                    )}

                    <div style={{ position: 'relative' }}>
                        <div
                            id="container"
                            style={{
                                overflowY: 'auto',
                            }}>
                            {!isLoadingFetchMemoDetail && memoDetail?.content && (
                                <MDXEditor
                                    readOnly={record.is_archived}
                                    markdown={memoDetail.content}
                                    onChange={(md) => {
                                        handleClickChange(md)
                                    }}
                                    plugins={record.is_archived ? SHORT_PLUGINS : ALL_PLUGINS}
                                />
                            )}
                        </div>
                        {record.is_archived == false && (
                            <Grid
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'flex-end',
                                    [theme.breakpoints.down('sm')]: {
                                        justifyContent: 'center',
                                    },
                                }}>
                                <Button
                                    disabled={isLoadingUpdateMemo}
                                    onClick={handleClickSaveChange}
                                    variant="contained"
                                    color="primary"
                                    sx={{
                                        height: '36px',
                                        mb: '24px',
                                    }}>
                                    {isLoadingUpdateMemo && <CircularProgress size={14} />}
                                    Сохранить изменения
                                </Button>
                            </Grid>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}
